import * as React from 'react';
const SvgInfo = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.333 9A8.333 8.333 0 11.667 9a8.333 8.333 0 0116.666 0zm-1.666 0A6.667 6.667 0 112.333 9a6.667 6.667 0 0113.334 0zm-7.115 4.586c-.854 0-1.135-.523-1.135-1.008 0-.204.064-.51.115-.688l.891-3.843H7.38a.208.208 0 01-.202-.256l.063-.27a.292.292 0 01.233-.222l2.365-.416a.417.417 0 01.478.506l-1.2 4.985a.158.158 0 00.276.137l.97-1.188a.268.268 0 01.429.322l-.584.844c-.611.892-1.172 1.097-1.656 1.097zm.281-8.218c0 .42.332.777.919.777.573 0 .994-.318 1.121-.828.025-.103.039-.217.039-.307 0-.42-.332-.777-.919-.777-.56 0-.994.318-1.121.828a1.371 1.371 0 00-.039.307z"
            fill="currentColor"
        />
    </svg>
);
export default SvgInfo;
